const rooms = [
  {
    id: 1,
    name: 'King Room with Mountain View',
    price: 14,
    amenities: ['WiFi', 'AC', 'TV', 'Balcony', '1 King Bed'],
    image: '/assets/king.png',
    description: 'A luxurious room with breathtaking mountain views, featuring 1 king bed for ultimate comfort and relaxation.'
  },
  {
    id: 2,
    name: 'Deluxe Single Room',
    price: 13,
    amenities: ['WiFi', 'AC', 'TV', 'Living Area', '1 Twin Bed'],
    image: '/assets/deluxe_single.png',
    description: 'Indulge in sophistication with our Deluxe Single Room, equipped with 1 twin bed and premium amenities.'
  },
  {
    id: 3,
    name: 'Deluxe Double or Twin Room',
    price: 14,
    amenities: ['WiFi', 'AC', 'TV', '2 Twin Beds'],
    image: '/assets/twin.png',
    description: 'Perfect for couples or friends, this room offers 2 twin beds in a comfortable and stylish setting.'
  },
  {
    id: 4,
    name: 'Deluxe Triple Room',
    price: 17,
    amenities: ['WiFi', 'AC', 'TV', 'Balcony', '1 Twin Bed + 1 King Bed'],
    image: '/assets/triple.png',
    description: 'Ideal for groups, featuring 1 twin bed and 1 king bed for spacious accommodation.'
  },
  {
    id: 5,
    name: 'Family Room with Mountain View',
    price: 20,
    amenities: ['WiFi', 'AC', 'TV', 'Balcony', '2 King Beds'],
    image: '/assets/family.png',
    description: 'Designed for families seeking luxury, with 2 king beds and stunning mountain views.'
  }
];

export default rooms;